import React from "react";

const RefundPolicy = () => {
    return (
        <div className="p-6 bg-gray-100 min-h-screen">
            <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-8">
                <h1 className="text-3xl font-bold text-gray-800 mb-6">
                    Refund and Cancellation Policy
                </h1>
                <p className="text-sm text-gray-600 mb-6">
                    Effective Date: 01 Jan 2025
                </p>
                <p className="text-gray-700 leading-relaxed mb-6">
                    At CodeBasera Tech, we are committed to transparency and ensuring our
                    users understand the terms associated with their donations to our associated
                    organizations. This Refund and Cancellation Policy outlines the terms under
                    which donations can be canceled and clarifies the refund process.
                </p>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">
                        1. Recurring Donation Subscriptions
                    </h2>
                    <div className="space-y-4">
                        <div>
                            <h3 className="text-lg font-medium text-gray-700">
                                1.1 Pause or Cancellation
                            </h3>
                            <p className="text-gray-700">
                                Users can pause or cancel their recurring donation subscriptions
                                at any time through the app. Any payments scheduled after the pause
                                or cancellation will not be processed.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-lg font-medium text-gray-700">
                                1.2 Resumption of Subscription
                            </h3>
                            <p className="text-gray-700">
                                Users can restart their paused or canceled subscription at any time.
                                Upon restarting, the next scheduled payment will be processed as per
                                the original terms.
                            </p>
                        </div>
                    </div>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">2. One-Time Donations</h2>
                    <p className="text-gray-700">
                        Donations made as a one-time payment cannot be canceled once the transaction
                        is completed.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">3. Refund Policy</h2>
                    <div className="space-y-4">
                        <div>
                            <h3 className="text-lg font-medium text-gray-700">No Refunds</h3>
                            <p className="text-gray-700">
                                All donations, whether recurring or one-time, are final and
                                non-refundable once processed.
                            </p>
                        </div>
                        <div>
                            <h3 className="text-lg font-medium text-gray-700">Receipts Provided</h3>
                            <p className="text-gray-700">
                                For every successful transaction, a digital receipt will be
                                provided to the user via the app. This receipt can be used for tax
                                purposes, including claiming benefits under Section 80G of the
                                Income Tax Act (if applicable).
                            </p>
                        </div>
                    </div>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">4. Registered Organizations</h2>
                    <p className="text-gray-700">
                        All organizations collecting donations through the app are verified and
                        registered with the government. They possess valid 80G certifications,
                        ensuring your donations are eligible for tax exemptions as per the
                        applicable laws.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">5. Dispute Resolution</h2>
                    <p className="text-gray-700">
                        If there are issues related to transactions (e.g., duplicate charges or
                        technical errors), users can contact us at{" "}
                        <a
                            href="mailto:contact@codebasera.com"
                            className="text-blue-600 underline"
                        >
                            contact@codebasera.com
                        </a>
                        . We will work with the user and the concerned organization to resolve
                        disputes promptly.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">6. Changes to This Policy</h2>
                    <p className="text-gray-700">
                        We may update this Refund and Cancellation Policy from time to time. Any
                        changes will be reflected on our website and app, and users will be notified
                        of significant updates.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Contact Us</h2>
                    <p className="text-gray-700">
                        If you have any questions or concerns regarding this Refund and
                        Cancellation Policy, please reach out to us:
                    </p>
                    <p className="text-gray-700">
                        <strong>Email:</strong>{" "}
                        <a
                            href="mailto:contact@codebasera.com"
                            className="text-blue-600 underline"
                        >
                            contact@codebasera.com
                        </a>
                    </p>
                    <p className="text-gray-700">
                        <strong>Phone:</strong> +91 7842943189
                    </p>
                </section>
            </div>
        </div>
    );
};

export default RefundPolicy;
